import { routes } from "Library/Constants";
import images from "Assets/images";

const profileMenu = [
  {
    id: 1,
    name: "my_account",
    icon: images.profileUser,
    redirectLink: routes.profile.account,
  },
  {
    id: 2,
    name: "my_organization",
    icon: images.profileOrg,
    redirectLink: routes.profile.organization,
  },
  {
    id: 3,
    name: "notification_preferences",
    icon: images.ProfileNotification,
    redirectLink: routes.profile.notification,
  },
];

export default profileMenu;

export const headerMenu = [
  {
    id: 1,
    name: "Project List",
    icon: images.profileUser,
    redirectLink: routes.auth.choseProject,
  },
  {
    id: 2,
    name: "My Account",
    icon: images.profileUser,
    redirectLink: routes.profile.account,
  },
  {
    id: 3,
    name: "My Organization",
    icon: images.profileOrg,
    redirectLink: routes.profile.organization,
  },
  {
    id: 4,
    name: "Notification",
    icon: images.ProfileNotification,
    redirectLink: routes.profile.notification,
  },
];
